import { AfterViewInit, Component, CUSTOM_ELEMENTS_SCHEMA, Input, OnInit, ViewChild } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { CommonModule } from '@angular/common';
import { ImagePipe } from 'src/app/pipes/image/image';
import { register } from 'swiper/element/bundle';
import { TranslateModule } from '@ngx-translate/core';
import { EventoDetalhesPage } from 'src/app/pages/evento/evento-detalhes/evento-detalhes.page';
import { EventoPage } from 'src/app/pages/evento/evento.page';
register();

@Component({
  selector: 'slider-eventos',
  templateUrl: 'slider-eventos.html',
  styleUrls: ['./slider-eventos.scss'],
  standalone: true,
  imports: [
    CommonModule,
    ImagePipe,
    TranslateModule
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})

export class SliderEventosComponent implements OnInit, AfterViewInit {
  @ViewChild('swiperElement', { static: false }) swiperElementRef!: any;
  @Input()
  config: any = {};
  eventoList: any = [];
  maximoEventos: any = {
    maximo: false,
    maximoQtd: 0
  };

  constructor(public modalCtrl: ModalController) { }

  ngAfterViewInit(): void {
    const swiperEl = this.swiperElementRef?.nativeElement;
    if (swiperEl) {
      swiperEl.initialize?.();
    }
  }

  ngOnInit() {
    if (this.config.idCategoriaEvento == -1) {
      this.eventoList = this.config.tipos_eventos_slider.eventosApp;
    } else {
      if (this.config.tipos_eventos_slider.eventosApp.length >= 6) {
        this.maximoEventos.maximo = true;
        this.maximoEventos.maximoQtd = this.config.tipos_eventos_slider.eventosApp.length - 6;
      }
      this.eventoList = this.config.tipos_eventos_slider.eventosApp.slice(0, 5);
    }

    setTimeout(() => {
      const swiperEl = this.swiperElementRef?.nativeElement;
      swiperEl?.initialize?.();
    }, 90);
  }

  getFontColor() {
    return this.config.font_color;
  }

  async abrirEvento(evento: { id: string; }) {
    const modalPage = await this.modalCtrl.create({
      component: EventoDetalhesPage,
      componentProps: { id: evento.id, isEnsino: false },
    });
    modalPage.present();
  }

  async abrirCategoria() {
    const modalProps = { params: String(this.config.tipos_eventos_slider.projeto), categorias: this.config.idCategoriaEvento };
    const modalPage = await this.modalCtrl.create({
      component: EventoPage,
      componentProps: modalProps,
    });
    modalPage.present();
  }
}
